import { useMutation } from '@tanstack/react-query';
import { useChat } from '../../../../../../../contexts/chat/ChatContext';
import { FormAction } from '../../../../../../../models/SidePanelTypes';

export const useTableAction = () => {
    const { dataSidePanelAction } = useChat();
    return useMutation({
        mutationFn: ({ sessionId, formAction, data }: { sessionId: string, formAction: FormAction, data?: Record<string, any>; }) => {
            return dataSidePanelAction(sessionId, formAction, data);
        },
    });
};